import type { AttendancePlayer } from '../types'

const getSortResult = (a: any, b: any, sortOrder: 'asc' | 'desc') => {
  if (a < b) {
    return sortOrder === 'asc' ? -1 : 1
  }
  if (a > b) {
    return sortOrder === 'asc' ? 1 : -1
  }
  return 0
}

const toNum = (v: unknown) =>
  typeof v === 'string' ? parseInt(v, 10) : (v as number)

export const getSortMethod =
  (sortType: string, sortOrder: 'asc' | 'desc') =>
  (a: AttendancePlayer, b: AttendancePlayer): number => {
    if (sortType === 'name') {
      const r = getSortResult(
        (a.name_last ?? '').toLowerCase(),
        (b.name_last ?? '').toLowerCase(),
        sortOrder
      )
      if (r !== 0) {
        return r
      }
      return getSortResult(
        (a.name_first ?? '').toLowerCase(),
        (b.name_first ?? '').toLowerCase(),
        sortOrder
      )
    }
    if (sortType === 'position') {
      return getSortResult(
        (a.player_type?.abbreviation ?? '').toLowerCase(),
        (b.player_type?.abbreviation ?? '').toLowerCase(),
        sortOrder
      )
    }
    // default: number
    return getSortResult(
      toNum(a.player_number),
      toNum(b.player_number),
      sortOrder
    )
  }

// Roster (skaters) vs Roster Spares (affiliates: is_affiliate || is_spare).
export const getPlayersAndAffiliates = (players: AttendancePlayer[] = []) => {
  const skaters: AttendancePlayer[] = []
  const affiliates: AttendancePlayer[] = []
  players.forEach((p) => {
    if (p.is_affiliate || p.is_spare) {
      affiliates.push(p)
    } else {
      skaters.push(p)
    }
  })
  return { skaters, affiliates }
}

// Eligible Game Spares: unpromoted spare candidates that carry a request.
export const getEligibleGameSpares = (
  spareCandidates: AttendancePlayer[] = []
) => spareCandidates.filter((p) => !!p.availability_request && !p.is_promoted)

// player id → availability_request id, for promoted candidates (echoed into
// Roster Spares, whose CONFIRM checkbox de-promotes via this id).
export const getPromotedCandidateRequestById = (
  spareCandidates: AttendancePlayer[] = []
): Record<string, string> => {
  const map: Record<string, string> = {}
  spareCandidates.forEach((c) => {
    if (c.is_promoted && c.availability_request?.id) {
      map[c.id] = c.availability_request.id
    }
  })
  return map
}
